import type { ReactNode } from "react";
import cn from "~/kernel/styling/className";

type Padding = "none" | "small" | "default";

type CardProps = {
  children: ReactNode;
  padding?: Padding;
};

export default function Card(props: CardProps) {
  return (
    <div
      className={cn(
        "flex-1 rounded-lg shadow-xl bg-white border border-slate-200",
      )}
    >
      <CardHeader {...props} />
      <CardBody {...props} />
      <CardFooter {...props} />
    </div>
  );
}

type CardHeaderProps = Pick<CardProps, "padding">;

function CardHeader({ padding = "default" }: CardHeaderProps) {
  return (
    <div
      className={cn({
        "px-3 pt-8 md:pt-12": padding === "default",
        "pt-5": padding === "small",
      })}
    ></div>
  );
}

type CardBodyProps = Pick<CardProps, "padding" | "children">;

function CardBody({ children, padding = "default" }: CardBodyProps) {
  return (
    <div
      className={cn({
        "px-3 md:px-12": padding === "default",
        "px-5": padding === "small",
      })}
    >
      {children}
    </div>
  );
}

type CardFooterProps = Pick<CardProps, "padding">;

function CardFooter({ padding = "default" }: CardFooterProps) {
  return (
    <div
      className={cn({
        "px-3 pb-8 md:pb-12": padding === "default",
        "pb-5": padding === "small",
      })}
    ></div>
  );
}
